import { signal } from "@preact/signals-react";
import { Window } from "@progress/kendo-react-dialogs";

export const showImageLabelWindow = signal(false);
export const imageLabelSrc = signal("");
export const imageLabelFieldName = signal("");

export const ImageLabelViewWindow = () => {
  if (!showImageLabelWindow.value) return null;

  return (
    <Window
      title={imageLabelFieldName.value}
      onClose={() => {
        showImageLabelWindow.value = false;
        imageLabelSrc.value = "";
        imageLabelFieldName.value = "";
      }}
      initialHeight={600}
      initialWidth={800}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: "20px",
        }}
      >
        {imageLabelSrc.value ? (
          <img
            src={imageLabelSrc.value}
            alt={imageLabelFieldName.value}
            style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
          />
        ) : (
          <span>No image configured</span>
        )}
      </div>
    </Window>
  );
};
